/**
 * Matches a protocol (e.g. http:, https:, ftp:, mailto:, etc.)
 */
const PROTOCOL_REGEX = /^[a-z][a-z0-9\+\-\.]+\:/i;

export function parseUrlObject(src: string): UrlWithRelativePath | null {
  if (!src) {
    return null;
  }
  try {
    const publicURL = (process.env.PUBLIC_URL || process.env.NEXT_PUBLIC_URL) as string;

    // If it's a fully qualified url, use it as is, otherwise include the public url

    if (src.match(PROTOCOL_REGEX)) return new URL(src);
    const urlWithDummyDomain = new URL(src, new URL(publicURL));
    const removeLeadingSlash = src.startsWith('#') || src.startsWith('?');
    return new UrlWithRelativePath(urlWithDummyDomain, removeLeadingSlash);
  } catch {
    return null;
  }
}

export class UrlWithRelativePath {
  href: string;
  pathname: string;
  protocol: string;
  origin: string;
  search: string;
  hash: string;

  constructor(url: URL, removeLeadingSlash: boolean = false) {
    this.href = url.href.replace(url.origin, '').toLowerCase();
    if (removeLeadingSlash) {
      this.href = this.href.replace(/^\//, '');
    }
    this.pathname = url.pathname;
    this.protocol = '';
    this.origin = '';
    this.search = url.search;
    this.hash = url.hash;
  }
  toString() {
    return this.href;
  }
  toJSON() {
    return this.href;
  }
}

export function standardizeGuid(guid: string): string {
  return guid.replaceAll('-', '').toLowerCase().trim();
}

export function guidsAreEqual(id: string | undefined, comparator: string | undefined) {
  if (!id || !comparator) return false;
  return standardizeGuid(id) === standardizeGuid(comparator);
}

export function stripHtmlTags(html: string | undefined) {
  return html?.replace(/<[^>]*>/g, '').trim();
}
